var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGroup6 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#C76306",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12.29V20h-5.016v-7.177c0-1.878-.784-3.16-2.51-3.16-1.32 0-2.055.866-2.395 1.698-.13.3-.109.717-.109 1.135V20H7S7.065 7.288 7 6.132h4.97V8.31C12.264 7.357 13.853 6 16.385 6 19.53 6 22 7.993 22 12.29zM0 20L5 20 5 6 0 6zM4 1.999C4 3.115 3.228 4 1.99 4h-.025C.772 4 0 3.12 0 2.001 0 .861.795 0 2.013 0 3.228 0 3.975.86 4 1.999z",
    transform: "translate(1 1)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroup6, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/group-6.137fc195.svg";
export { ForwardRef as ReactComponent };